module.exports = __webpack_public_path__ + "img/page.5f6dab9f.png";